enum NavigationIcons {
	COMPANIES = 'CompaniesIcon',
	DASHBOARD = 'DashboardIcon',
	PROJECTS = 'ProjectsIcon',
	REQUESTS = 'DocumentsAllIcon',
	DOCUMENT = 'DocumentIcon',
	DATABASE = 'DatabaseIcon',
	FAVORITE = 'FavoriteIcon',
	INBOX = 'InboxIcon',
	JOB_POSTING = 'JobPostingIcon',
	GROUPS = 'GroupsIcon',
	MANAGER = 'ManagerIcon',
	MARKETPLACE = 'MarketplaceIcon',
	MY_CONTRACTOR_DATABASE = 'ManagerContractorDBIcon',
	ALL_DOCUMENTS = 'DocumentsAllIcon',
	CONTRACTORS_DOCUMENTS = 'DocumentsContractors',
	PROJECTS_DOCUMENTS = 'DocumentsProjectsIcon',
	APPLICATIONS = 'ApplicationIcon',
	NETWORK = 'NetworkIcon',
	NOTIFICATIONS = 'BellIcon',
	CONTRACTORS = 'ContractorsIcon',
	GROUP = 'SidenavGroupsIcon',
	RECRUITING = 'RecruitingIcon',
	JOB_BOARD = 'JobBoardIcon',
	SETTINGS = 'SettingsIcon',
	SCHEDULE = 'SchedulerIcon',
	LOCATION = 'LocationIcon',
}

export default NavigationIcons;
